<template>
  <div class="widget" v-bind:class="[{'loaded':loaded},className]" v-if="$aclInterfaceValidator('weeboxshop.order.statsca')">

    <header class="widget-header">
      <h2 class="widget-title">{{ title }}</h2>
      <h3 class="widget-title-period">
        <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
      </h3>

      <div class="widget-actions-container">
        <div><form-toggle label="" v-model="is_ttc" label-true="TTC" label-false="HT"></form-toggle></div>
        <widget-dropdown v-model="type" :options="types" :callback="filterByType"></widget-dropdown>
        <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
      </div>

      <div class="form-advanced-filter" v-if="showAdvancedFilterVue">
        <span>Filtrer par date</span>
        <div class="date-filters">
          <form-datetime label="du" v-model="dateFilter.start_at" :hide-time="true" time="00:00:00"></form-datetime>
          <form-datetime label="au" v-model="dateFilter.end_at" :hide-time="true" time="23:59:59"></form-datetime>
        </div>
      </div>


    </header>

    <div class="widget-preloader">
      <div class="pre-loader">
        <div class="box1"></div>
        <div class="box2"></div>
        <div class="box3"></div>
        <div class="box4"></div>
        <div class="box5"></div>
      </div>
    </div>

    <div class="widget-content" v-if="stats.dataset">
      <div class="widget-content-datas">
        <div class="data-labels">

          <div class="data-label" v-if="is_ttc">
            <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ (existing.total + isnew.total)|formatNumber }}</strong>
            <span class="compare-to-previous">
              <compare :previous="(existing.total_compare + isnew.total_compare)" :current="(existing.total + isnew.total)" :currency="currency"></compare>
            </span>
            <span class="legend">Total sur {{ existing.count + isnew.count }} commande(s)</span>
          </div>

          <div class="data-label" v-if="!is_ttc">
            <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ (existing.total_ht + isnew.total_ht)|formatNumber }}</strong>
            <span class="compare-to-previous">
                      <compare :previous="(existing.total_compare_ht + isnew.total_compare_ht)" :current="(existing.total_ht + isnew.total_ht)" :currency="currency"></compare>
                    </span>
            <span class="legend">Total sur {{ existing.count + isnew.count }} commande(s)</span>
          </div>

          <div class="data-label" v-if="is_ttc">
            <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ existing.total|formatNumber }}</strong>
            <span class="compare-to-previous">
              <compare :previous="existing.total_compare" :current="existing.total" :currency="currency"></compare>
            </span>
            <span class="legend">Clients existants<br>{{ existing.count }} commande(s)</span>
          </div>

          <div class="data-label" v-if="!is_ttc">
            <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ existing.total_ht|formatNumber }}</strong>
            <span class="compare-to-previous">
                      <compare :previous="existing.total_compare_ht" :current="existing.total_ht" :currency="currency"></compare>
                    </span>
            <span class="legend">Clients existants<br>{{ existing.count }} commande(s)</span>
          </div>

          <div class="data-label" v-if="is_ttc">
            <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ isnew.total|formatNumber }}</strong>
            <span class="compare-to-previous">
              <compare :previous="isnew.total_compare" :current="isnew.total" :currency="currency"></compare>
            </span>
            <span class="legend">Nouveaux clients<br>{{ isnew.count }} commande(s)</span>
          </div>

          <div class="data-label" v-if="!is_ttc">
            <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ isnew.total_ht|formatNumber }}</strong>
            <span class="compare-to-previous">
                      <compare :previous="isnew.total_compare_ht" :current="isnew.total_ht" :currency="currency"></compare>
                    </span>
            <span class="legend">Nouveaux clients<br>{{ isnew.count }} commande(s)</span>
          </div>

          <div class="data-label" v-if="is_ttc">
            <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ (average_cart)|formatNumber }}</strong>
            <span class="compare-to-previous">
              <compare :previous="(average_cart_compare)" :current="(average_cart)" :currency="currency"></compare>
            </span>
            <span class="legend">Panier moyen</span>
          </div>

          <div class="data-label" v-if="!is_ttc">
            <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ (average_cart_ht)|formatNumber }}</strong>
            <span class="compare-to-previous">
              <compare :previous="(average_cart_compare_ht)" :current="(average_cart_ht)" :currency="currency"></compare>
            </span>
            <span class="legend">Panier moyen</span>
          </div>

        </div>

      </div>

      <div class="widget-chart" v-bind:class="{'active':stats.labels.length}" @click="setChartToFull">
        <chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="stats"></chart>
      </div>
    </div>
  </div>
</template>
<script>

    import InvoiceService from './InvoiceService.js';
    import Chart from '../../../components/chart/Bar.vue'

    export default {
      name: 'Widget',
      components: {
        'chart' : Chart
      },
      props: ['title','type','period','className','branch'],
      data () {
        return {
          types: [
            {id: 'all', label: 'Global'},
            {id: 'web', label: 'Web uniquement'},
            {id: 'direct', label: 'Direct uniquement'}
          ],
          periods: [
            {id: 'last_7days', label: '7 derniers jours'},
            {id: 'current_month', label: 'Ce mois'},
            {id: 'last_month', label: 'Le mois dernier'},
            {id: 'since_1_month', label: '30 derniers jours'},
            {id: 'since_3_months', label: '90 derniers jours'},
            {id: 'current_year', label: 'Cette année'},
            {id: 'last_year', label: 'Depuis 12 mois'},
            {id: 'all', label: 'Tout'},
            {id: 'custom', label: 'Personnalisé'},
          ],
          forceRefresh: null,
          loaded: false,
          stats: {
            dataset: null,
            labels: null
          },
          dateFilter: {
            start_at: '',
            end_at: '',
          },
          showAdvancedFilterVue: false,
          average_cart: null,
          average_cart_ht: null,
          average_cart_compare: null,
          average_cart_compare_ht: null,
          existing: null,
          isnew: null,
          currency: null,
          is_ttc: true,
          options: {
            __custom: {
              borderWidth: 1,
              transparentBackgroundTop: 0.4,
              transparentBackgroundBottom: 0.6
            },
            plugins: {
              labels: false
            },
            legend: {
              labels: {
                usePointStyle: true,
                boxWidth: 6,
                fontSize: 10,
                fontFamily: 'Gotham Rounded',
                fontWeight: 300
              }
            },
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
              }
            },
            scales: {
              xAxes: [ {
                categoryPercentage: 0.9,
                barPercentage: 0.9,
                stacked: true,
                steppedLine: true,
                gridLines: {
                  offsetGridLines: false,
                  display: false,
                  color: "#eeeeee",
                  drawBorder: false
                },
                ticks: {
                  display: true,
                  fontColor: "#cccccc",
                  fontSize: 10,
                  mirror: false,
                  padding: 0,
                  align: 'start',
                  fontFamily: 'Gotham Rounded',
                  fontWeight: 300
                },
              }],
              yAxes: [
                {
                  id: 'bar',
                  order: 1,
                  stacked: true,
                  steppedLine: true,
                  gridLines: {
                    offsetGridLines: true,
                    display: true,
                    color: "#eeeeee",
                    borderDashOffset: 1,
                    borderDash: [2,2],
                    drawBorder: false
                  },
                  ticks: {
                    fontColor: "#cccccc",
                    fontSize: 10,
                    display: true,
                    padding: 0,
                    fontFamily: 'Gotham Rounded',
                    fontWeight: 300
                    //stepSize: 1,
                    //suggestedMax: 0,
                    //suggestedMin: 0
                  }
                },
                {
                  id: 'average',
                  order: 1000,
                  stacked: false,
                  steppedLine: true,
                  position: 'right',
                  gridLines: {
                    offsetGridLines: true,
                    display: true,
                    color: "#eeeeee",
                    borderDashOffset: 1,
                    borderDash: [2,2],
                    drawBorder: false
                  },
                  ticks: {
                    fontColor: "#cccccc",
                    fontSize: 10,
                    display: true,
                    padding: 0,
                    fontFamily: 'Gotham Rounded',
                    fontWeight: 300,
                    stepSize: 10,
                    suggestedMax: 100,
                    suggestedMin: 0
                  }
                }
              ]
            }
          }
        }
      },
      mounted: function(){
        this.currency = this.$store.state.scope.currency_id
        this.is_ttc = this.$store.state.scope.is_ttc
        this.period = this.period ? this.period : this.periods[0].id

        if(this.period == 'custom') {
          this.showAdvancedFilterVue = true
        }else{
          this.showAdvancedFilterVue = false;
        }

        this.filterByPeriod(this.period);

      },
      watch: {
        'dateFilter.start_at'(newVal, oldVal) {
          if(newVal != '' && this.dateFilter.end_at != ''){
            this.filterByPeriodAndByDate(this.period, this.dateFilter);
          }
        },
        'dateFilter.end_at'(newVal, oldVal) {
          if(newVal != '' && this.dateFilter.start_at != ''){
            this.filterByPeriodAndByDate(this.period, this.dateFilter);
          }
        }
      },
      methods: {
        setChartToFull: function()
        {
          this.options.layout.padding = {
            left: -10,
            right: 0,
            top: 0,
            bottom: -10
          };
          this.options.scales.xAxes[0].ticks.display = true;
          this.options.scales.xAxes[0].gridLines.display = true;
          this.options.scales.yAxes[0].ticks.display = true;

        },
        filterByType: function(type)
        {
          this.type = type
          this.filterByPeriod(this.period)
        },
        filterByPeriod: function(period)
        {

          if(period == 'custom') {
            this.showAdvancedFilterVue = true
          }else{
            this.showAdvancedFilterVue = false;
          }

          if(period != 'custom') {

            this.loaded = false;
            this.period = period

            InvoiceService.getStatsAquisition( this.type, this.period, this.branch).then((response) => {
              this.stats.dataset = response.data.result.stats.dataset
              this.stats.labels = response.data.result.stats.labels

              this.existing = response.data.result.existing
              this.isnew = response.data.result.new

              this.average_cart = response.data.result.average_cart
              this.average_cart_ht = response.data.result.average_cart_ht
              this.average_cart_compare = response.data.result.average_cart_compare
              this.average_cart_compare_ht = response.data.result.average_cart_compare_ht


              this.loaded = true;
            }).catch((response) => {
              console.log("error", response);
              this.loaded = true;
            })

          }
        },
        filterByPeriodAndByDate: function(period, dateFilter)
        {
          this.loaded = false;

          this.period = period
          this.date = JSON.stringify(dateFilter);

          InvoiceService.getStatsAquisition( this.type, this.period, this.branch, this.date ).then((response) => {
            this.stats.dataset = response.data.result.stats.dataset
            this.stats.labels = response.data.result.stats.labels

            this.existing = response.data.result.existing
            this.isnew = response.data.result.new

            this.average_cart = response.data.result.average_cart
            this.average_cart_ht = response.data.result.average_cart_ht
            this.average_cart_compare = response.data.result.average_cart_compare
            this.average_cart_compare_ht = response.data.result.average_cart_compare_ht

            this.loaded = true;
          }).catch((response) => {
            console.log("error", response);
            this.loaded = true;
          })
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/modules/invoicing/invoice/StatsAquisitionWidget.vue